import axios from 'axios'
import qs from 'qs'
let baseURL = 'https://admin.rakumart.com'


//获取问卷详情 
export const surveyDetail = data => axios({
    url: baseURL + "/index.php?mod=inc&mod=inc&act=hms_api&str=questionnaire_get",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
}
)

//客户提交问卷填写内容
export const surveyAnswer = data => axios({
    url: baseURL + "/index.php?mod=inc&mod=inc&act=hms_api&str=questionnaire_reply",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
}
)

//获取用户token
export const get_token = data => axios({
    url: baseURL + "/index.php?mod=inc&act=hms_api&str=get_token",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
}
)


